/**
 * Suppresses specific console warnings containing a given substring.
 * Usage: Import and call this function at the top of your entry point (e.g., _app.tsx).
 */
export function suppressExternalPromiseWarning(): void {
  const originalWarn = console.warn
  const warningPattern = 'The generated code contains \'async/await\''
  console.warn = function (...args: unknown[]): void {
    if (typeof args[0] === 'string' && args[0].includes(warningPattern)) {
      return
    }
    originalWarn.apply(console, args)
  }
}
